module.exports = __webpack_public_path__ + "static/media/card-self-awareness.2626eebc.svg";